import MainBlock from "../block/main_blocks/block_privacy";
import PrivacyBlock from "../block/privacy_block";
import { useEffect } from "react";

export default function Privacy({settem, setIsOpenPopUp}) {
    useEffect(() => {
        document.title = 'Политика конфиденциальности';
      }, []);
    return(
        <main>
            <MainBlock />
            <PrivacyBlock />
        </main>
    )
}